import { createAction, handleActions } from "redux-actions";
import takeRight from "lodash/takeRight";
import { isTouchDevice } from "../Map";

export const initialState = {
  isSmallScreen: false,
  isTouchScreen: false,
  // mid level
  resultDataVisibile: false,
  infoVisible: false,
  layersVisible: false,
  customLayerRestroomVisible: false,
  printVisible: false,
  drawVisible: false,
  legendVisible: false,
  spreadsheetVisible: false,
  accordions: [
    "resultDataVisibile",
    "infoVisible",
    "layersVisible",
    "customLayerRestroomVisible",
    "printVisible",
    "drawVisible",
    "legendVisible",
    "spreadsheetVisible",
  ],
  maxVisibleAccordions: 10,
  // misc
  lastUpdated: {},
};

export const actionAppIsSmallScreenUpdated = createAction(
  "APP_IS_SMALL_SCREEN_UPDATED",
);
export const actionAppIsTouchScreenUpdated = createAction(
  "APP_IS_TOUCH_SCREEN_UPDATED",
);
export const actionAppComponentToggled = createAction("APP_COMPONENT_TOGGLED");
export const actionAppAccordionsRearranged = createAction(
  "APP_ACCORDIONS_REARRANGED",
);
export const actionAppMaxVisibleAccordionsUpdated = createAction(
  "APP_MAX_VISIBLE_ACCORDIONS_UPDATED",
);
export const actionAppDateUpdated = createAction("APP_DATE_UPDATED");

export const actionAppToggleComponent = (payload) => {
  return (dispatch, getState) => {
    const state = getState().appReducer;
    const { component, visible } = payload;
    const visibility =
      visible === null || visible === undefined ? !state[component] : visible;

    if (state.accordions.indexOf(component) === -1) {
      dispatch(actionAppComponentToggled({ component, visibility }));
      return;
    }

    const accordions = rearrangeAccordions(
      state.accordions,
      component,
      visibility,
    );
    const hideAccordions = syncVisibleAccordions(state, accordions);
    dispatch(actionAppAccordionsRearranged(accordions));
    dispatch(actionAppComponentToggled({ component, visibility }));
    hideAccordions.forEach((component) => {
      dispatch(actionAppComponentToggled({ component, visibility: false }));
    });
  };
};

export const actionAppToSmallScreen = (isSmallScreen) => {
  return (dispatch, _getState) => {
    dispatch(actionAppIsSmallScreenUpdated(isSmallScreen));
    dispatch(actionAppIsTouchScreenUpdated(isTouchDevice()));
  };
};

export const appReducer = handleActions(
  {
    [actionAppIsSmallScreenUpdated]: (state, action) => {
      return { ...state, isSmallScreen: action.payload };
    },
    [actionAppIsTouchScreenUpdated]: (state, action) => {
      return { ...state, isTouchScreen: action.payload };
    },
    [actionAppComponentToggled]: (state, action) => {
      const { component, visibility } = action.payload;
      return { ...state, [component]: visibility };
    },
    [actionAppAccordionsRearranged]: (state, action) => {
      return { ...state, accordions: action.payload };
    },
    [actionAppMaxVisibleAccordionsUpdated]: (state, action) => {
      return { ...state, maxVisibleAccordions: action.payload };
    },
    [actionAppDateUpdated]: (state, action) => {
      return { ...state, lastUpdated: action.payload };
    },
  },
  initialState,
);

export const selectorAppIsSmallScreen = (state) =>
  state.appReducer.isSmallScreen;
export const selectorAppIsTouchScreen = (state) =>
  state.appReducer.isTouchScreen;

function rearrangeAccordions(accordions, component, visibility) {
  const newAccordion = [...accordions];

  if (!visibility) {
    return accordions;
  }

  const targetIndex = newAccordion.indexOf(component);
  newAccordion.splice(targetIndex, 1);
  newAccordion.unshift(component);
  return newAccordion;
}

function syncVisibleAccordions(state, accordions) {
  const { maxVisibleAccordions } = state;
  if (accordions.length <= maxVisibleAccordions) {
    return [];
  }

  const rightCount = accordions.length - maxVisibleAccordions;
  const toHide = takeRight(accordions, rightCount);
  return toHide;
}
